{% block prems_discount_category_selector_content %}
    <div class="sw-condition-line-item-in-category sw-condition__condition-value">
        <sw-entity-multi-select
            :label="$tc('prems-discount-category.detail.card.base.field.categoryIdsLabel')"
            size="medium"
            entity="category"
            :entityCollection="categories"
            @update:entity-collection="setCategoryIds"
        >
        </sw-entity-multi-select>
    </div>
{% endblock %}